import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import ParticleField from './ParticleField';
import RotatingText from './RotatingText';
import ThreeHeroScene from './ThreeHeroScene';

const STATS = [
  { n: '12+', l: 'Launches shipped' },
  { n: '24/7', l: 'Automation uptime' },
  { n: '4wk', l: 'Typical MVP sprint' },
  { n: '1', l: 'Partner for build and growth' },
];

const ROTATING_LINES = [
  'automation that runs 24/7',
  'web experiences people remember',
  'lead systems that close faster',
  'AI workflows that cut manual work',
];

export default function Hero() {
  const badgeRef = useRef(null);
  const h1Ref = useRef(null);
  const kickerRef = useRef(null);
  const subRef = useRef(null);
  const ctaRef = useRef(null);
  const statsRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({ delay: 0.25 });
    tl.from(badgeRef.current, { opacity: 0, y: 24, duration: 0.6, ease: 'power3.out' })
      .from(
        h1Ref.current.querySelectorAll('.hero-line'),
        { opacity: 0, y: 70, stagger: 0.13, duration: 0.9, ease: 'power4.out' },
        '-=0.15'
      )
      .from(kickerRef.current, { opacity: 0, y: 18, duration: 0.55, ease: 'power3.out' }, '-=0.45')
      .from(subRef.current, { opacity: 0, y: 22, duration: 0.7, ease: 'power3.out' }, '-=0.4')
      .from(
        ctaRef.current.children,
        { opacity: 0, y: 22, stagger: 0.14, duration: 0.6, ease: 'power3.out' },
        '-=0.35'
      )
      .from(
        statsRef.current.children,
        { opacity: 0, y: 18, stagger: 0.1, duration: 0.5, ease: 'power3.out' },
        '-=0.2'
      );
  }, []);

  const goto = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero section">
      <ThreeHeroScene />
      <ParticleField />
      <div className="hero-content">
        <div ref={badgeRef} className="hero-badge">
          <span className="hero-badge-dot" />
          Full-stack digital & AI studio
        </div>

        <h1 ref={h1Ref} className="hero-title">
          <span className="hero-line">Crafted for Growth,</span>
          <span className="hero-line">
            built to <span className="hero-emphasis"></span>
            <span className="hero-emphasis">Stand Out</span>
          </span>
          
        </h1>

        <p ref={kickerRef} className="hero-kicker">
          We build <RotatingText items={ROTATING_LINES} />
        </p>

        <p ref={subRef} className="hero-subtitle">
          From web and mobile products to SEO, ads, WhatsApp, and AI automation,
          we design systems that look premium and keep working long after launch.
        </p>

        <div ref={ctaRef} className="hero-cta">
          <button className="btn btn-primary" onClick={() => goto('services')}>
            Explore services
          </button>
          <button className="btn btn-ghost" onClick={() => goto('showcase')}>
            Preview our work
          </button>
        </div>

        <div ref={statsRef} className="hero-stats">
          {STATS.map((s) => (
            <div key={s.l} className="hero-stat">
              <strong>{s.n}</strong>
              <span>{s.l}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="hero-scroll" />
    </section>
  );
}
